import { useState } from "react";

export default function ShareButtons() {
  const [copied, setCopied] = useState(false);
  const [toast, setToast] = useState("");

  const actions = [
    { icon: "ri-wechat-line", label: "分享到微信" },
    { icon: "ri-weibo-line", label: "分享到微博" },
    { icon: "ri-link", label: "复制链接" },
  ];

  const handleClick = (label: string) => {
    if (label === "复制链接") {
      setCopied(true);
      setToast("链接已复制（演示效果）");
      setTimeout(() => setCopied(false), 2000);
    } else {
      setToast(`已生成${label}的分享卡片（演示效果）`);
    }
    setTimeout(() => setToast(""), 2200);
  };

  return (
    <div className="relative">
      <div className="flex items-center gap-2.5">
        <span className="text-xs text-foreground-500 mr-1">分享：</span>
        {actions.map((action) => (
          <button
            key={action.label}
            type="button"
            title={action.label}
            aria-label={action.label}
            onClick={() => handleClick(action.label)}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
          >
            <i className={`${action.icon === "ri-link" && copied ? "ri-check-line" : action.icon} text-base`}></i>
          </button>
        ))}
      </div>
      {toast && (
        <div className="absolute left-0 top-full mt-2 px-3 py-1.5 rounded-md bg-foreground-900 text-background-50 text-xs whitespace-nowrap z-10 animate-fade-in">
          {toast}
        </div>
      )}
    </div>
  );
}